var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"checkout-input-order-type"},[_vm._m(0),_c('SelectionAccordion',{attrs:{"name":"orderType","value":_vm.orderType,"options":_vm.orderTypeOptions},on:{"input":_vm.setOption}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',[_c('h4',[_vm._v("Order Type")])])
}]

export { render, staticRenderFns }